import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PravaPristupaService {

  constructor(public _http: Http) { }

  dohvati(a:any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'vezes/dohvatiPopisAdminu', a)    
    .map(res => res.json()); 
  }

  dodajPrava(a:any){
    return this._http.post(AppConfig.apiAdresaMongoVimeo + 'vezes/?access_token=' + localStorage.getItem('token'), a)
    .map(res => res.json()); 
  }

  urediPrava(id: any, a:any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'vezes/uredi/' + id, a)
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/prava-pristupa/prava-pristupa.service.ts